import { zApiEntity, zRelationships } from './chunk-H27MX3SA.js';
import { z } from 'zod';

var zUserRole = z.union([
  z.literal("ADMIN"),
  z.literal("MANAGER"),
  z.literal("CONTENT-EDITOR"),
  z.literal("READ-ONLY")
]);
var zUser = zApiEntity("user").extend({
  email: z.string(),
  name: z.string(),
  company_name: z.string(),
  job_title: z.string(),
  metadata: z.object({
    role: zUserRole
  }),
  relationships: zRelationships({ sites: "site" })
});
var zPrimaryResponsibility = zApiEntity("primary_responsibility").extend({
  id: z.number(),
  metadata: z.object({
    name: z.string()
  })
});

export { zPrimaryResponsibility, zUser, zUserRole };
//# sourceMappingURL=chunk-2XXSK4OM.js.map
//# sourceMappingURL=chunk-2XXSK4OM.js.map